import { Brand, createBranded } from '@deltasierra/type-utilities';

export type AssetId = Brand<number, 'AssetId'>;
export const AssetId = createBranded<AssetId>();
